// Shared by the static generator and the browser. URLs must not diverge when
// the browser loads a single-language catalog instead of the full build input.
const transliteration: Record<string, string> = {
  а: "a", б: "b", в: "v", г: "g", д: "d", е: "e", ё: "e", ж: "zh",
  з: "z", и: "i", й: "i", к: "k", л: "l", м: "m", н: "n", о: "o",
  п: "p", р: "r", с: "s", т: "t", у: "u", ф: "f", х: "h", ц: "c",
  ч: "ch", ш: "sh", щ: "sch", ъ: "", ы: "y", ь: "", э: "e", ю: "yu", я: "ya",
};

export function slugify(value: unknown, maximum = 72): string {
  return [...String(value ?? "").toLocaleLowerCase("ru")]
    .map(character => transliteration[character] ?? character).join("")
    .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
    .slice(0, maximum).replace(/-+$/g, "") || "offer";
}

export function websiteProductPath(
  product: { id: string; product_ru?: string; product_ro?: string; product_uk?: string },
  catalog: { id: string },
  locale: "ru" | "ro" | "uk",
): string {
  const title = locale === "ro" ? product.product_ro
    : locale === "uk" ? product.product_uk || product.product_ru || product.product_ro
    : product.product_ru || product.product_ro;
  return `/${locale}/${locale === "ro" ? "produs" : "tovar"}/${slugify(title, 56)}-${catalog.id}-${product.id}/`;
}
